"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Text = _typography.default.Text;
var Option = _select.default.Option;
var FormItem = _form.default.Item;
var MAX_RELATED_GROUPS_COUNT = 3;
var RelatedGroupForm = function RelatedGroupForm(_ref) {
  var form = _ref.form,
    relatedGroups = _ref.relatedGroups,
    groups = _ref.groups,
    onAddRelatedGroup = _ref.onAddRelatedGroup,
    onRemoveRelatedGroup = _ref.onRemoveRelatedGroup,
    onSelectChange = _ref.onSelectChange,
    onSubmit = _ref.onSubmit;
  var getFieldDecorator = form.getFieldDecorator;
  var relatedGroupIds = relatedGroups.map(function (relatedGroup) {
    return relatedGroup.id;
  });
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, formValues) {
      if (err) {
        return;
      }
      var related = Object.keys(formValues).map(function (id) {
        return {
          relatedGroupId: id
        };
      });
      onSubmit({
        related: related
      });
    });
  };
  return /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "related-groups-form"
  }, relatedGroups.map(function (relatedGroup, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_row.default, {
      type: "flex",
      justify: "space-between",
      align: "middle",
      className: "related-group-header"
    }, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(Text, {
      strong: true
    }, "Related Group ", index + 1)), /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "close-circle",
      theme: "filled",
      className: "text-danger",
      onClick: function onClick() {
        return onRemoveRelatedGroup(relatedGroup.id);
      }
    }))), /*#__PURE__*/_react.default.createElement(FormItem, {
      className: "floating-label"
    }, getFieldDecorator(relatedGroup.id, {
      initialValue: relatedGroup.name,
      rules: [{
        required: true,
        message: 'Please select group'
      }]
    })( /*#__PURE__*/_react.default.createElement(_select.default, {
      onSelect: function onSelect(value) {
        return onSelectChange(value, index);
      },
      placeholder: "Select Group",
      size: "large"
    }, groups.map(function (group) {
      return !relatedGroupIds.includes(group.id) && /*#__PURE__*/_react.default.createElement(Option, {
        key: group.id,
        value: group.id
      }, group.name);
    })))));
  }), relatedGroups.length < MAX_RELATED_GROUPS_COUNT && /*#__PURE__*/_react.default.createElement(FormItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    icon: "plus",
    type: "link",
    className: "ant-btn-sm",
    onClick: onAddRelatedGroup
  }, !relatedGroups.length ? 'Add related group' : 'Add another related group')), /*#__PURE__*/_react.default.createElement(FormItem, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    style: {
      width: '100%'
    }
  }, "Save Changes")));
};
var _default = _form.default.create()(RelatedGroupForm);
exports.default = _default;